/**
 * Pending Approval page - shown to users awaiting manual approval
 */

import { useAuth } from '../hooks/useAuth'

export const PendingApproval = () => {
  const { user, logout, refetch } = useAuth()

  return (
    <div className="min-h-[calc(100vh-200px)] bg-gradient-to-br from-slate-50 via-amber-50 to-orange-50 -m-6 p-6">
      <div className="max-w-2xl mx-auto text-center py-16">
        {/* Icon */}
        <div className="inline-flex items-center justify-center w-20 h-20 bg-gradient-to-br from-amber-400 to-orange-500 rounded-2xl shadow-lg mb-8">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-10 w-10 text-white"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            strokeWidth={2}
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
            />
          </svg>
        </div>

        {/* Title */}
        <h1 className="text-3xl font-bold text-gray-900 mb-4">Application Received</h1>

        {/* Message */}
        <p className="text-lg text-gray-600 mb-8 max-w-md mx-auto">
          Thanks for signing up! Your account is pending approval. We&apos;ll notify you at{' '}
          <span className="font-medium text-gray-800">{user?.email}</span> once your access is
          confirmed.
        </p>

        {/* What happens next */}
        <div className="bg-white rounded-xl p-6 shadow-sm border border-gray-100 text-left mb-8">
          <h2 className="text-lg font-semibold text-gray-900 mb-4">What happens next?</h2>
          <ul className="space-y-3 text-gray-600">
            <li className="flex items-start">
              <span className="flex-shrink-0 w-6 h-6 bg-amber-100 rounded-full flex items-center justify-center mr-3 mt-0.5">
                <span className="text-amber-600 text-sm font-medium">1</span>
              </span>
              Our team will review your application
            </li>
            <li className="flex items-start">
              <span className="flex-shrink-0 w-6 h-6 bg-amber-100 rounded-full flex items-center justify-center mr-3 mt-0.5">
                <span className="text-amber-600 text-sm font-medium">2</span>
              </span>
              You&apos;ll receive an email when approved
            </li>
            <li className="flex items-start">
              <span className="flex-shrink-0 w-6 h-6 bg-amber-100 rounded-full flex items-center justify-center mr-3 mt-0.5">
                <span className="text-amber-600 text-sm font-medium">3</span>
              </span>
              Click &quot;Check my status&quot; below to refresh your access
            </li>
          </ul>
        </div>

        {/* Contact */}
        <p className="text-sm text-gray-500 mb-6">
          Questions? Contact us at{' '}
          <a
            href="mailto:sales@scientistintheloop.com"
            className="text-amber-600 hover:text-amber-700"
          >
            sales@scientistintheloop.com
          </a>
        </p>

        {/* Check status button */}
        <button
          onClick={() => refetch()}
          className="bg-amber-500 hover:bg-amber-600 text-white px-6 py-2 rounded-lg font-medium transition-colors mb-4"
        >
          Check my status
        </button>

        {/* Logout button */}
        <button
          onClick={() => logout()}
          className="block mx-auto text-gray-500 hover:text-gray-700 text-sm underline"
        >
          Sign out
        </button>
      </div>
    </div>
  )
}
